import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FieldArray, Form, Formik } from 'formik'
import { database, databaseRef } from 'utils/firebase'
import { useAlert } from 'react-alert'
import { prescriptionTemplateSchema } from 'validationSchema'
import { useEffect, useState } from 'react'
import { push, update, ref } from 'firebase/database'
import { useSelector } from 'react-redux'
import styles from '../../../styles.module.scss'
import Medication from '../../../../patient/consult/subComponents/Medication'
import CustomInput from '../../../../../components/CustomInputs/CustomInput'
import { addDoctorLog } from 'utils/functions'

const AddModal = ({ isOpen, closeModal, edit, editKey, templates }) => {
  const [initialValues, setInitialValues] = useState({
    name: '',
    medications: [
      {
        name: '',
        composition: '',
        route: '',
        dosage: '',
        frequency: '',
        duration: '',
        quantity: '',
        refills: '',
        instructions: '',
        warning: '',
      },
    ],
  })
  const { me } = useSelector((state) => state.app)

  const alert = useAlert()
  const handleSubmit = async (values, action) => {
    const prescriptionRef = ref(database, 'templates/prescription')
    const newPrescriptionRef = push(prescriptionRef)
    const hashKey = newPrescriptionRef.key
    
    const updates = {}
    updates[`templates/prescription/${hashKey}`] = values
    await update(ref(database), updates)
    closeModal()
    alert.success('Added')

    addDoctorLog({
      action: 'CREATE_PRESCRIPTION_TEMPLATE',
      category: 'template',
      description: `Created new prescription template: ${values.name}`,
      doctorID: me.id,
      details: {
        templateId: hashKey, // The key generated when creating
        templateName: values.name,
        timestamp: Date.now()
      }
    })
  }
  
  const handleEditSubmit = async (values, action) => {
    const updates = {}
    updates[`templates/prescription/${editKey}`] = values
    await update(ref(database), updates)
    closeModal()
    alert.success('Updated')

    addDoctorLog({
      action: 'UPDATE_PRESCRIPTION_TEMPLATE',
      category: 'template',
      description: `Updated prescription template: ${values.name}`,
      doctorID: me.id,
      details: {
        templateId: editKey,
        templateName: values.name,
        timestamp: Date.now()
      }
    })
  }

  useEffect(() => {
    if (editKey) {
      setInitialValues(templates[editKey])
    }
  }, [editKey])

  // ** Root
  return (
    <Modal isOpen={isOpen} centered size="lg">
      <ModalHeader toggle={closeModal}>
        <span className={styles.title}>
          {edit ? 'Edit' : 'New'} Prescription Template
        </span>
      </ModalHeader>
      <ModalBody>
        <div>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={edit ? handleEditSubmit : handleSubmit}
            validationSchema={prescriptionTemplateSchema}
          >
            {(props) => (
              <Form>
                <div className="mb-4">
                  <CustomInput
                    label="Template Name"
                    name="name"
                    placeholder="493 Allergy - Bronchitis "
                  />
                </div>
                <FieldArray
                  name="medications"
                  render={(arrayHelpers) => (
                    <div>
                      {props.values.medications.map((med, index) => (
                        <Medication
                          index={index}
                          key={index}
                          remove={arrayHelpers.remove}
                          arrayHelpers={arrayHelpers}
                          disableTemplates
                        />
                      ))}
                      <div className="d-flex justify-content-end mt-2">
                        <button
                          onClick={() => {
                            arrayHelpers.push({
                              name: '',
                              composition: '',
                              route: '',
                              dosage: '',
                              frequency: '',
                              duration: '',
                              quantity: '',
                              refills: '',
                              instructions: '',
                              warning: '',
                            })
                          }}
                          type="button"
                          className={styles.button}
                        >
                          Add New Medication
                        </button>
                      </div>
                    </div>
                  )}
                />
                <hr />
                <div className="d-flex justify-content-end">
                  <button
                    type="submit"
                    className={styles.SaveBtn}
                    disabled={props.isSubmitting}
                  >
                    {edit ? 'Update' : 'Save'} Template
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default AddModal
